import React from 'react';
import { withStyles, CircularProgress } from '@material-ui/core';
import { primaryColor } from '../utils/colors';

const CenteredCircularProgress = withStyles({
	root: {
		color: primaryColor,
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
	},
})(CircularProgress);

const CenteredCustomSpinner = props => {
	return <CenteredCircularProgress {...props} />;
};

export default CenteredCustomSpinner;